import { render, staticRenderFns } from "./NotificationWrapper.html?vue&type=template&id=4ee2eadf&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationWrapper.scss?vue&type=style&index=0&id=4ee2eadf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2eadf",
  null
  
)

export default component.exports